import { useEffect, useState } from "react";
import Spinner from "./Spinner";

// Small, pleasant fallback for Suspense / "loading" states.
// Key UX detail: delay avoids flashing a loader for fast transitions.
export default function LoadingFallback({
  delayMs = 180,
  spinnerSize = 28,
  label = "Chargement",
  className = "",
}) {
  const [visible, setVisible] = useState(delayMs === 0);

  useEffect(() => {
    if (delayMs === 0) return undefined;
    const id = setTimeout(() => setVisible(true), delayMs);
    return () => clearTimeout(id);
  }, [delayMs]);

  if (!visible) return null;

  return (
    <div
      className={`flex items-center justify-center py-10 text-gray-500 ${className}`}
      role="status"
      aria-live="polite"
      aria-label={label}
    >
      <Spinner size={spinnerSize} />
    </div>
  );
}

